export default "__VITE_ASSET__WrVTBDDH__"